import { getLocalizedString } from "@icarius-localization/strings";
import { getAmountEditorOptions, dateEditorOptions, lookupColumnEditorOptions, amountEditorOptions, amountEditorOptionsMax0, amountEditorOptionsMax2 } from '../constants/editorOptions';

export const decimals = {
    [getLocalizedString("grossReportedValue")]: 4,
    [getLocalizedString("liquidReportedValue")]: 3,
    [getLocalizedString("percentage")]: 0,
    [getLocalizedString("cant")]: 3,
    [getLocalizedString("calculationBase")]: 5,
};

export const dateFormat = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
};

export const formatNumberOptionsMax0 = {
    type: "fixedPoint",
    precision: 0
};

export const getDynamicFormat = (decimalsCount) => {
    if (!decimalsCount || decimalsCount === 0) return "#,##0";
    return "#,##0." + "#".repeat(decimalsCount);
};

export const getFormat = (gridName, item) => {
    if (item.isDate) return dateFormat;
    if (item.isNumeric) {
        if (gridName === "holidayTable") return formatNumberOptionsMax0;
        
        let decimalsCount = 3;
        if (["dataCapture", "massEntry", "entryPerSociety"].includes(gridName) && item.headerName !== getLocalizedString("cant")) {
            decimalsCount = 2;
        } else if (gridName === "entryPerConcept" && [getLocalizedString("cant"), getLocalizedString("grossReportedValue"), getLocalizedString("liquidReportedValue"), getLocalizedString("percentage"), getLocalizedString("calculationBase")].includes(item.headerName)) {
            decimalsCount = decimals[item.headerName] || 0;
        }
        
        return getDynamicFormat(decimalsCount);
    }
    return null;
};

export const getEditorOptions = (gridName, item) => {
    if (item.isDate) return dateEditorOptions;
    if (item.isSelect) return lookupColumnEditorOptions;
    if (item.isNumeric) {
        if (gridName === "holidayTable") return amountEditorOptionsMax0;
        if (["dataCapture", "massEntry", "entryPerSociety"].includes(gridName) && item.headerName !== getLocalizedString("cant")) return amountEditorOptionsMax2;
        if (gridName === "entryPerConcept" && [getLocalizedString("cant"), getLocalizedString("grossReportedValue"), getLocalizedString("liquidReportedValue"), getLocalizedString("percentage"), getLocalizedString("calculationBase")].includes(item.headerName)) return getAmountEditorOptions(decimals[item.headerName]);
        return amountEditorOptions;
    }
    return null;
};
